var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{key:_vm.applicationHook,class:_vm.$vuetify.rtl ? "rtl iransans" : "ltr inter",style:({
    background:
      _vm.$vuetify.theme.themes[_vm.$vuetify.theme.dark === true ? 'dark' : 'light']
        .background
  }),attrs:{"id":"inspire"}},[_c('transitionPage',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }